(() => {
  angular
    .module('gm.common.services')
    .factory('FormAlert', FormAlertFactory);

  function FormAlertFactory(
    $rootScope,
    $timeout,
    $log
  ) {
    'ngInject';

    const _defaultTimeout = 3000;
    let _showFormAlert = false;
    let _timeoutPromise;

    function showAlert() {
      $timeout.cancel(_timeoutPromise);
      $rootScope[_showFormAlert] = true;
    }

    function btgFormAlert(showFormAlert) {
      // handle attributes
      if ((angular.isUndefined(showFormAlert)) || (!angular.isString(showFormAlert))) {
        $log.debug('Incorrect showFormAlert variable passed');

        return;
      }

      _showFormAlert = showFormAlert;

      // lifecycle events
      $rootScope.$on('$destroy', () => {
        $timeout.cancel(_timeoutPromise);
      });
    }

    btgFormAlert.prototype.hide = function _hide() {
      // hide the alert
      $timeout.cancel(_timeoutPromise);
      $rootScope[_showFormAlert] = false;
    };

    btgFormAlert.prototype.show = function _show(origTimeout) {
      // handle attributes
      if (angular.isUndefined(origTimeout)) {
        // no timeout, just show the alert
        showAlert();
      } else {
        let timeout;
        if ((!angular.isNumber(origTimeout)) || ((origTimeout % 1) !== 0)) {
          $log.debug('Incorrect timeout value passed');
          timeout = _defaultTimeout;
        } else {
          timeout = origTimeout;
        }

        // show the alert
        showAlert();
        _timeoutPromise = $timeout(() => {
          $rootScope[_showFormAlert] = false;
        }, timeout);
      }
    };

    return btgFormAlert;
  }
})();
